import { render } from "./TagCloud.vue?vue&type=template&id=5c1d0c74"
import script from "./TagCloud.vue?vue&type=script&lang=js"
export * from "./TagCloud.vue?vue&type=script&lang=js"

import "./TagCloud.vue?vue&type=style&index=0&id=5c1d0c74&lang=css"
script.render = render

export default script